import { render, staticRenderFns } from "./Users-Order-History-List.vue?vue&type=template&id=2451194b&scoped=true&"
import script from "./Users-Order-History-List.vue?vue&type=script&lang=js&"
export * from "./Users-Order-History-List.vue?vue&type=script&lang=js&"
import style0 from "./Users-Order-History-List.vue?vue&type=style&index=0&id=2451194b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2451194b",
  null
  
)

export default component.exports